
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Share2 } from "lucide-react";
import { ShareFolderDialog } from "../ShareFolder";
import { ManageFolderSharesDialog } from "../ManageFolderShares";

interface FolderShareButtonProps {
  folderId: string;
  projectId: string;
  folderName: string;
}

const FolderShareButton: React.FC<FolderShareButtonProps> = ({
  folderId,
  projectId,
  folderName
}) => {
  const [isShareDialogOpen, setIsShareDialogOpen] = useState(false);
  const [isManageSharesOpen, setIsManageSharesOpen] = useState(false);

  return (
    <>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsShareDialogOpen(true)}
        >
          <Share2 className="h-3.5 w-3.5 mr-1.5" />
          Dela
        </Button>

        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsManageSharesOpen(true)}
        >
          Hantera delningar
        </Button>
      </div>

      
      <ShareFolderDialog 
        isOpen={isShareDialogOpen}
        onOpenChange={setIsShareDialogOpen}
        folderId={folderId}
        projectId={projectId}
        folderName={folderName}
      />
      
      <ManageFolderSharesDialog
        isOpen={isManageSharesOpen}
        onOpenChange={setIsManageSharesOpen}
        folderId={folderId}
        folderName={folderName}
      />
    </>
  );
};

export default FolderShareButton;
